import { useEffect } from 'react';
import { n as noop } from '../index-a0e4e333.js';
import 'prop-types';
import '../dateValidation-67caec66.js';
import '../_commonjsHelpers-24198af3.js';
import 'react-dom';

const useMount = function () {
  let onMount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
  return useEffect(onMount, []);
};

export { useMount as default };
